export function isAndroidBrowser(navigator: Navigator | undefined): boolean {
  return Boolean(navigator?.userAgent.match(/android/i));
}
